import React from 'react'

import { renderFieldHelpText } from './HelpText'
import { UploadedFiles } from './UploadedFiles'
import * as styles from './ViewFormModal.styles'
import { type FieldComponentProps, type FileUploadFormField } from './fieldTypes'

export const FileUploadField = ({ field, onPreviewFile }: FieldComponentProps<FileUploadFormField>) => {
  return (
    <styles.GroupField>
      <styles.FieldLabel>{field.label}</styles.FieldLabel>
      {renderFieldHelpText(field.helpText)}
      <styles.UploadedFiles>
        <UploadedFiles files={field.files} onPreviewFile={onPreviewFile} />
      </styles.UploadedFiles>
    </styles.GroupField>
  )
}
